module.exports = __webpack_public_path__ + "assets/icon_order_highlight.aa77b507.svg";